export enum ImplicationEnum {
  Simple = 'Simple',
  Multiple = 'Multiple'
}
